import { render, staticRenderFns } from "./PlaceholderCard.vue?vue&type=template&id=82883f92"
import script from "./PlaceholderCard.vue?vue&type=script&lang=js"
export * from "./PlaceholderCard.vue?vue&type=script&lang=js"
import style0 from "./PlaceholderCard.vue?vue&type=style&index=0&id=82883f92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports